__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pad-tatico";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.7.0", function() { return Promise.all([__webpack_require__.e(678), __webpack_require__.e(522), __webpack_require__.e(462)]).then(function() { return function() { return __webpack_require__(4678); }; }); });
			register("@emotion/styled", "11.11.0", function() { return Promise.all([__webpack_require__.e(522), __webpack_require__.e(405), __webpack_require__.e(10)]).then(function() { return function() { return __webpack_require__(1878); }; }); });
			register("@mui/material", "5.10.1", function() { return Promise.all([__webpack_require__.e(741), __webpack_require__.e(706), __webpack_require__.e(522), __webpack_require__.e(405), __webpack_require__.e(531)]).then(function() { return function() { return __webpack_require__(2706); }; }); });
			register("@mui/styles", "5.10.7", function() { return Promise.all([__webpack_require__.e(727), __webpack_require__.e(522), __webpack_require__.e(509)]).then(function() { return function() { return __webpack_require__(5727); }; }); });
			register("i18next", "21.6.14", function() { return Promise.all([__webpack_require__.e(178), __webpack_require__.e(237)]).then(function() { return function() { return __webpack_require__(178); }; }); });
			register("react-dom", "17.0.1", function() { return Promise.all([__webpack_require__.e(164), __webpack_require__.e(522), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(4164); }; }); });
			register("react-i18next", "12.1.4", function() { return Promise.all([__webpack_require__.e(522), __webpack_require__.e(230)]).then(function() { return function() { return __webpack_require__(9230); }; }); });
			register("react-router-dom", "5.2.0", function() { return Promise.all([__webpack_require__.e(542), __webpack_require__.e(522), __webpack_require__.e(360)]).then(function() { return function() { return __webpack_require__(1542); }; }); });
			register("react", "17.0.1", function() { return __webpack_require__.e(791).then(function() { return function() { return __webpack_require__(2791); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};